export const config = {
  baseUrl: 'https://assets.mave.work',
  // baseUrl: 'https://assets-test.mave.work',
  baseUrlDev: 'http://assets.development'
}
